import { useEffect, useState } from "react";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import styles from "./containerreports.module.css";
import { TableLoader } from "../../../components/ContentLoader";
import { Calendar, Eye, Home, Search, X } from "react-feather";
import { Button, Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { DateRangePicker } from "rsuite";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import axios from "axios";
import dayjs from "dayjs";
import { CurrencyFormatter } from "../../../components/Helpers";
import { Link } from "react-router-dom";
import ContainerReportDetails from "./ContainerReportDetails";

const ContainerReports = () => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const [filterDate, setFilterDate] = useState(null);
    const [contentLoading, setContentLoading] = useState(true);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedContainer, setSelectedContainer] = useState(null);

    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    useEffect(() => {
        fetchOrders();
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (page === 0) {
            fetchOrders();
        } else {
            setPage(0);
        }
    }, [searchKey, filterDate]);

    const fetchOrders = () => {
        axios.get(process.env.REACT_APP_API_URL + "v1/report/container-report", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            },
            params: {
                page: page + 1,
                per_page: rowsPerPage,
                search: searchKey,
                start_date: filterDate ? dayjs(filterDate[0]).format("YYYY-MM-DD") : null,
                end_date: filterDate ? dayjs(filterDate[1]).format("YYYY-MM-DD") : null,
            }
        }).then((response) => {
            setContentLoading(false);

            setAllData(response.data.data.data);
            setTotalCount(response.data.data.total);
        }).catch(() => {
            setContentLoading(false);
        });
    }

    return (<>
        <div className={`${styles.MainDiv}`}>
            <div className={`${styles.MainCard}`}>
                {contentLoading && <TableLoader />}

                {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
                    <p className={`${styles.PageTitle}`}>Container Reports</p>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Reports</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>Container Reports</li>
                        </ol>
                    </nav>
                </div>)}
                {!contentLoading && (<>
                    <div className={`${styles.TableFilterHead}`}>
                        <div className={`${styles.DataTableSearch}`}>
                            <Search className={`${styles.SearchIcon}`} />
                            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                            {searchKey !== "" && (<Button type="button" className={`${styles.CloseBU}`} onClick={(e) => setSearchKey("")}><Close /></Button>)}
                        </div>
                        <div className={`${styles.FilterCard}`}>
                            <div className={`${styles.DashFilterSec}`}>
                                <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} value={filterDate} showOneCalendar onChange={(e) => setFilterDate(e)} />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.CusTable}`}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <StyledMainTableCell>Shipping Id</StyledMainTableCell>
                                        <StyledMainTableCell>Container Id</StyledMainTableCell>
                                        <StyledMainTableCell>Shipping Date</StyledMainTableCell>
                                        <StyledMainTableCell>Arrival Date</StyledMainTableCell>
                                        <StyledMainTableCell>ETA</StyledMainTableCell>
                                        <StyledMainTableCell>No Of Bookings</StyledMainTableCell>
                                        <StyledMainTableCell>Total Booking Amount</StyledMainTableCell>
                                        <StyledMainTableCell>&nbsp;</StyledMainTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {allData.map((item, index) => {
                                        return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <TableCell component="th" scope="row">{item?.reference_id}</TableCell>
                                            <TableCell component="th" scope="row">{item?.container_no}</TableCell>
                                            <TableCell component="th" scope="row">{dayjs(item?.shipping_date).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell component="th" scope="row">{item?.arrival_date ? dayjs(item?.arrival_date).format('DD/MM/YYYY') : '-'}</TableCell>
                                            <TableCell component="th" scope="row">{item?.eta_of_container ? dayjs(item?.eta_of_container).format('DD/MM/YYYY') : '-'}</TableCell>
                                            <TableCell component="th" scope="row">{item?.no_of_bookings}</TableCell>
                                            <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.total_booking_amount))}</TableCell>
                                            <TableCell component="th" scope="row"><Link onClick={(e) => { setViewModalOpen(true); setSelectedContainer(item); }}><Eye /></Link></TableCell>
                                        </StyledMainTableRow>);
                                    })}

                                    {allData.length === 0 && (<TableRow>
                                        <TableCell colSpan={6} align="center">No data found</TableCell>
                                    </TableRow>)}

                                </TableBody>
                                {totalCount > 0 && (<TableFooter>
                                    <TableRow>
                                        <TablePaginationComponent
                                            count={totalCount}
                                            colSpan={6}
                                            page={page}
                                            rowsPerPage={rowsPerPage}
                                            handleChangePage={paginationChangePage}
                                            handleChangeRowsPerPage={paginationChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                                )}
                            </Table>
                        </TableContainer>
                    </div>
                </>)}
            </div>
        </div>

        <Dialog
            fullWidth
            maxWidth="lg"
            className={`${styles.NewPopUp}`}
            open={viewModalOpen}
            onClose={(e) => setViewModalOpen(false)}
        >
            <DialogTitle id="alert-dialog-title">
                Container Details: #{selectedContainer?.container_no}
                <button onClick={(e) => setViewModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <ContainerReportDetails containerId={selectedContainer?.id} />
            </DialogContent>
        </Dialog>
    </>);
};

export default withAdminAuth(ContainerReports);